
















































import _ from 'lodash'
import iconToggleButton from '@/elements/IconToggleButton.vue'
import toggle_switch from '@/form/Switch.vue'
import Vue from 'vue'
import { mapState } from 'vuex'
import * as clickAway from 'vue-clickaway'


export default {
  name: 'ClientList'

  components:
    'v-icon-toggle-button': iconToggleButton

  directives:
    'onClickaway': clickAway.directive

  data: () ->
    is_active: false
    filter_active: true
    show_year: null
    show_dropdown: false

  mounted: ()->
    if not @are_loaded.resources then await @$store.dispatch 'getServices'
    if not @are_loaded.client_list then await @$store.dispatch 'getClientList'

  methods:
    select: (client) ->
      @$store.dispatch 'selectClient', client

    clickYear: (year) ->
      if @show_year != year then @show_year = year else @show_year = null

    away: ->
      @show_dropdown = false

  computed:
    mapState
      client_list: (state) ->
        _.orderBy state.client_list.getEmbeds('clients'), ['id']

      selected_client: (state) ->
        state.selected_client

      resources: (state) ->
        state.resources

      unactive_list: ->
        list = @client_list.filter (item) =>
          item.end?
        console.log 'list: ', list

        new_list = _.groupBy list, (item) ->
          item.end.slice(0,4)

        console.log 'new_list: ', new_list
        new_list

      active_list: ->
        @client_list.filter (item) =>
          (item.end == null || item.end == '')

      are_loaded: (state) ->
        state.are_loaded
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ClientList.vue